const ticket = {
  createANewTicket: "Crear un Nuevo Ticket",
  subject: "Asunto",
  label: "Etiqueta",
  relatedEquipment: "Activo Relacionado",
  notAnEquipment: "Ninguno",
  description: "Descripción",
  submit: "Enviar",
  yourTickets: "Sus Tickets",
  issues: "Ticket de Software",
  mechanicalSupport: "Ticket de Hardware",
  suggestions: "Sugerencias",
  ticketProfile: "Detalles del Ticket",
  status: "Estatus",
  comments: "Comentarios",
  comment: "Comentario",
  addNewComment: "Agregar nuevo commentario",
  messages: {
    successful: "Ticket creado satisfactoriamente"
  },
  backbtn: "Atrás",
  modulesbtn: "Módulos"
};

export default ticket;
